import styles from './index.module.sass';
import { useLocation } from 'react-router-dom';
import { useRef } from 'react';
import { config, distributor } from 'config';

const Maps = () => {
  const location = useLocation();
  const iframeRef = useRef('');
  const sourceUrl = `${config.mapUrl}/${location.search}`;

  return (
    <iframe
      ref={iframeRef}
      sandbox="allow-scripts allow-popups allow-same-origin"
      className={styles.maps}
      src={sourceUrl}
      // src="http://10.64.132.189:8080" //測試用
      allow={`geolocation 'self' ${config.mapUrl}`}
      onLoad={() => {
        iframeRef.current.contentWindow.postMessage({ distributor: distributor() }, config.mapUrl);
      }}
      title="麻吉地圖"
    ></iframe>
  );
};

export default Maps;
